import { render } from "./ProjectPageHeader.vue?vue&type=template&id=0093ddd2"
import script from "./ProjectPageHeader.vue?vue&type=script&lang=js"
export * from "./ProjectPageHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__